{
  "schedule": "排程監控",
  "comm": "通訊監控",
  "webrtcStats": "WebRTC 統計",
  "webrtc": "網路電話",
  "host": "主機資源",
  "docs": "操作手冊"
}
